export default "__VITE_ASSET__CCdDOnXX__"